<template>
    <div class="app-changelog">
        <!-- BEGIN: Subheader -->
        
        <!-- END: Subheader -->


        <div class="m-content">
            <!--Begin::Section-->
            <div class="m-grid__item m-grid__item--fluid m-wrapper changelog-content" v-html="content">
                
            </div>
            <!--End::Section-->
        </div>
    </div>
</template>


<script>
import marked from 'marked';
marked.setOptions({
  renderer: new marked.Renderer(),
  highlight: function(code) {
    return require('highlight.js').highlightAuto(code).value;
  },
  pedantic: false,
  gfm: true,
  tables: true,
  breaks: false,
  sanitize: false,
  smartLists: true,
  smartypants: false,
  xhtml: false
});
export default {
    name: "app-changelog",
    data() {
        return {

        };
    },
    computed: {
        content() {
            var text = 
`
## v0.4
- menampilkan payment detail ketika status sudah complete
- error qty waktu terima / sent / retur
- update tampilan rupiah di beberapa datatable


## v0.3
- penambahan error waktu  login
- auto sort by tanggal di pembelian dan penjualan 
- nama produk required


## v0.2
- penambahan number masking di payment, mutasi
- add delete untuk transaksi pending

## v0.1
- add changelog page
- add update notes penjualan dan pembelian


`
;
 
 
 
            return marked(text);
        }
    }
};
</script>


<style lang="scss" >
    .app-changelog {
        text-align: left;
        font-size: 1.25rem;
        font-family: 'Courier New', Courier, monospace;
        ul {
            list-style: none;
            padding: 0px;
            margin-bottom: 3rem;
        }
        li {
            border-bottom: 1px solid #ccc;
        }
    }
</style>
